import { ReactNode } from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider } from './AuthContext';

// One init only. One Tap + the personalized sign-in button both come from the single
// <GoogleLogin useOneTap> in LoginGate, which only mounts while anon (and never during
// the boot refresh). A second google.accounts.id.initialize() here would be dropped by
// the GIS singleton and break the live card's click flow. Token expiry/refresh is handled
// reactively in authFetch (refresh-on-401) + signOut, so no timers here.
export default function GoogleAuthProvider({ children }: { children: ReactNode }) {
  const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID ?? '';
  if (!clientId) {
    return (
      <main className="min-h-screen flex items-center justify-center px-4 py-12 bg-[#f5f9e5] bg-[radial-gradient(120%_70%_at_50%_-10%,#fcfdf7_0%,#f5f9e5_38%,#d6deb4_100%)] font-trirong_light text-gray-800">
        <section className="w-full max-w-md rounded-3xl bg-[#fcfdf7] px-6 py-10 text-center shadow-lg shadow-lime-900/5 ring-1 ring-lime-900/5 md:px-10">
          <h1 className="font-trirong_reg text-2xl text-lime-800">New Dawn Counselling</h1>
          <p className="mt-3 font-trirong_light text-gray-600">
            The writing studio isn't configured yet. Set{' '}
            <code className="rounded bg-[#f5f9e5] px-1.5 py-0.5 font-trirong_reg text-lime-800">
              REACT_APP_GOOGLE_CLIENT_ID
            </code>{' '}
            to enable sign-in.
          </p>
        </section>
      </main>
    );
  }
  return (
    <GoogleOAuthProvider clientId={clientId}>
      <AuthProvider>{children}</AuthProvider>
    </GoogleOAuthProvider>
  );
}
